import { render, staticRenderFns } from "./Elpris.vue?vue&type=template&id=63d725bd&"
import script from "./Elpris.vue?vue&type=script&lang=js&"
export * from "./Elpris.vue?vue&type=script&lang=js&"
import style0 from "./Elpris.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports